import Mixin from "../../mixin.js";
import Funnel from "../../services/funnel-service.js";
import Utils from "../../services/utils-service.js";

const template = `
    <div :id="iuid" v-show="fs.display(input)" role="alert" aria-live="assertive" aria-atomic="true">
        <div :class="computedClassAlert">
            <div class="icon" :class="computedClassIcon">	
                <img alt="" v-if="input.icon_name" class="iconic iconic-sm" :data-state="(input.data_state) ? input.data_state : 'up'" :data-src="computedAlertIcon">
            </div>
            <div class="grid collapse">
                <div :class="computedClassContent" class="m-center clm">
                    <span v-if="input.value" class="text-left" @click="exec($event, input)" v-html="computedText" tabindex="0" role="button" aria-pressed="false"></span>
                    <div v-if="input.value_html" class="text-left" v-html="input.value_html" tabindex="0" role="document"></div>
                </div>
            </div>
        </div>
    </div>
`;

export default {
    name: 'b-alert',
    template,
    props: ['iuid'],
    mixins: [Mixin],
    data () {
        return {
          defaultIcon:'script'
        }
    },
    computed: {
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        },
        computedClassIcon: function () {
            if (this.input.icon_name) {
                return "banner-btn-icon"
            } else {
                return "no-show"
            }
        },
        computedAlertIcon: function(){
            var iconName = ''
            if (this.input.icon_name) {
                iconName = this.input.icon_name
            }
            else{
                iconName = this.defaultIcon;
            }
            return '/static/images/iconic/' + this.input.icon_name + '.svg'
        },
        computedClassAlert: function(){
            var classes = ['alert']

            if (!this.input.icon_name) {
                classes.push('no-icon');
            } 
            classes.push('rounded');

            classes.push(this.input.alert_type)

            return classes
        },
        reload(puid) {
            return this.$store.getters.funnel.elements[puid].page_reload;
        },
        computedClassContent: function () {
            var classes = []
            classes.push('m12');

            return classes;
        },
        computedClassBtn: function () {
            var classes = []
            classes.push("s6");
            classes.push("m4");

            return classes;
        },
        validationRules() {
            // v-bind="validationRules"
            return this.input.validation
        },
        input: function () {
            return this.$store.getters.funnel.elements[this.iuid];
        },
        computedText: function () {
          
            let alertText = this.input.value;

            if (!Utils.isObjEmpty(this.input.values)) {

                const fs = new Funnel({ ctx: this.$store, router: this.$router });

                for (const value of this.input.values) {
                    if (fs.display(value)) {
                        alertText = value.text;
                    }
                }
                
            }
            return alertText;
        }
    },
    methods: {
        redirect() {
            const puid = this.input.btn.route_uid;
            const ctrlDt = this.input.ctrlDt;
            if (!Utils.isEmpty(ctrlDt) && !Utils.isEmpty(ctrlDt.addPgToPosInSeq)) {
                this.$store.commit('ADD_PAGE_SEQ_TO_POS', [ctrlDt.addPgToPosInSeq]);
            }
            const route = this.$store.getters.funnel.elements[puid].page_route;
            this.$router.push(route);
        }
    }
};